import { useEffect, useRef, useState } from 'react';
import Button from 'components/button';
import { Building, Check, Loading2 } from 'assets/icons';
import useText from 'hooks/useText';
import { globalMotif, sourceKey } from 'pages/prospection/callListItems';

const EMPTY = '-';

const GlobalListRow = ({ prospect, added, onAdd }) => {
  const { text, plural } = useText('prospection');
  const [pending, setPending] = useState(false);
  const mounted = useRef(true);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    [],
  );

  const { company } = prospect;
  const sourceLabelKey = sourceKey(company.source);
  const contact =
    company.contactName || (sourceLabelKey ? text(sourceLabelKey) : EMPTY);
  const subline = text('global.subline', {
    contact,
    city: company.city || EMPTY,
  });
  const motif = globalMotif(prospect);
  const motifText =
    motif.count !== undefined
      ? plural(motif.key, motif.count, motif.values)
      : text(motif.key, motif.values);

  const handleAdd = async () => {
    setPending(true);
    try {
      await onAdd(prospect);
    } catch (error) {
      // The parent reports the failure; the button just comes back.
    } finally {
      if (mounted.current) setPending(false);
    }
  };

  return (
    <li className="flex items-center gap-3 py-3 border-b border-gray-100 last:border-b-0">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100">
        <Building wh={20} color="#6B7280" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="truncate font-medium text-gray-900">{company.name}</div>
        <div className="truncate ft-sm text-gray-500">{subline}</div>
        <div className="truncate ft-sm text-gray-500">{motifText}</div>
      </div>
      {added ? (
        <span className="flex shrink-0 items-center gap-1 ft-sm font-medium text-green-600">
          <Check wh={16} color="#16A34A" />
          <button
            type="button"
            disabled
            className="font-medium text-green-600"
          >
            {text('global.added')}
          </button>
        </span>
      ) : (
        <Button
          color="SECONDARY"
          disabled={pending}
          className="shrink-0"
          onClick={handleAdd}
        >
          {pending && <Loading2 wh={16} color="#6B7280" />}
          {text('global.add')}
        </Button>
      )}
    </li>
  );
};

export default GlobalListRow;
